export default __webpack_public_path__ + "static/media/text-allign-left.66bbe63c.svg";